import { CloseOutlined } from '@ant-design/icons';
import { Button } from '@mm/components';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { BudgetCapModalProps } from '@mm/state/modules/modalsState/props';
import { InputNumber, Radio } from 'antd';
import React, { useState } from 'react';
import styles from './BudgetCapModal.module.css';

export const BudgetCapModal = ({
  minValue = 1,
  defaultValue = 1,
  onSubmit,
  hasBudgetCap,
}: BudgetCapModalProps) => {
  const [limitOption, setLimitOption] = useState<number>(hasBudgetCap ? 2 : 1);
  const hasLimit = limitOption === 2;

  const [limitValue, setLimitValue] = useState<number | null>(defaultValue);
  const invalidInput = !limitValue || limitValue < defaultValue;
  const { closeModal } = useModalActions();

  const onChangeLimitOption = (val: number) => {
    setLimitOption(val);
    if (val === 1) {
      setLimitValue(null);
    } else {
      setLimitValue(defaultValue);
    }
  };

  const onConfirm = () => {
    const budgetCap = limitValue ? limitValue * 100 : null; // we sent in cents
    onSubmit(budgetCap);
  };

  return (
    <div className={styles.container}>
      <CloseOutlined
        className={styles.closeIcon}
        onClick={() => closeModal()}
      />

      <div className={styles.title}>
        Setting up the monthly limit
        <div className={styles.description}>
          To be sure you are spending not more then you want, please set up the
          limit{' '}
        </div>
      </div>

      <div className={styles.inputWrapper}>
        <div className={styles.radioInputs}>
          <Radio
            value={1}
            checked={limitOption === 1}
            className={styles.radioInput}
            onChange={e => onChangeLimitOption(e.target.value)}
          >
            No Limit
          </Radio>

          <div className={styles.limitedRadioInputWrapper}>
            <Radio
              value={2}
              checked={limitOption === 2}
              className={styles.radioInput}
              onChange={e => onChangeLimitOption(e.target.value)}
            >
              Set a limit
            </Radio>

            {hasLimit ? (
              <>
                <InputNumber
                  min={minValue}
                  status={invalidInput ? 'error' : ''}
                  formatter={value =>
                    `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }
                  value={limitValue}
                  onChange={val => {
                    setLimitValue(val);
                  }}
                  className={styles.input}
                />
                <span className={styles.note}>
                  {' '}
                  Your limit should not be less then{' '}
                  <span style={{ fontWeight: 500 }}>${defaultValue}</span>
                </span>
              </>
            ) : null}
          </div>
        </div>
      </div>
      <div className={styles.buttonsWrapper}>
        <Button
          color="blue"
          onClick={onConfirm}
          css={{ container: styles.button }}
          disabled={hasLimit && invalidInput}
        >
          Set up new Limit
        </Button>
      </div>
    </div>
  );
};
